export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    DEVICE_SERVICE_BUY_RULES_ALL: function DEVICE_SERVICE_BUY_RULES_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/device-service-buy-rules/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    DEVICE_SERVICE_BUY_RULES_CREATE: function DEVICE_SERVICE_BUY_RULES_CREATE(data) {
      return request({
        url: '/api/market-service-buy-rules/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_SERVICE_BUY_RULES_DETAIL: function DEVICE_SERVICE_BUY_RULES_DETAIL(id) {
      return request({
        url: '/api/market-service-buy-rules/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_SERVICE_BUY_RULES_UPDATE: function DEVICE_SERVICE_BUY_RULES_UPDATE(data) {
      return request({
        url: '/api/market-service-buy-rules/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    DEVICE_SERVICE_BUY_RULES_DELETE: function DEVICE_SERVICE_BUY_RULES_DELETE(id) {
      return request({
        url: '/api/market-service-buy-rules/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});